import React, { useEffect } from "react";
import { Close, Search } from "@material-ui/icons";
import * as message from "../../config/CommonMessages";
import * as code from "../../config/Constants";
import { toastMessage } from "../Common/Common";
import { useHistory, Link, useParams } from "react-router-dom";
import HeaderLogin from "../HeaderLogin/HeaderLogin";
import {
  getShopDetailsAction,
  getShopDetailsByPublicUrlAction,
} from "./../../actions/ShopActions";
import { Col, Form, Row, Carousel, Card, Button } from "react-bootstrap";
import { connect } from "react-redux";
import PhoneNumber from "../Common/phoneNumber";
import ReactHtmlParser from "react-html-parser";
import UserImage from "./../../assets/img/property-placeholder.jpg";
import UrlConstants from "./../../config/UrlConstants";
import { DebounceInput } from "react-debounce-input";
import noRecord from "./../../assets/img/no-record.png";

function ShopDetails({
  getShopDetailsAction,
  getShopDetailsByPublicUrlAction,
}) {
  const params = useParams();
  const shopNameParam = (params && params.name) || "";

  const history = useHistory();
  const [showLoader, setShowLoader] = React.useState(false);
  const [rerender, setRerender] = React.useState(0);
  const [shopData, setShopDetails] = React.useState({});
  const [searchParam, setSearchParam] = React.useState("");
  const [originalArtists, setOriginalArtists] = React.useState([]);
  const [filteredArtists, setFilteredArtists] = React.useState([]);

  useEffect(() => {
    //setShowLoader(true);

    if (history.location.state !== undefined && history.location.state.id) {
      getShopDetails(history.location.state.id);
    } else if (shopNameParam) {
      getShopDetailsByPublicUrl(shopNameParam.trim());
    } else {
      history.push({
        pathname: "/studios",
      });
    }
  }, [rerender]);

  function getShopDetails(ownerId) {
    getShopDetailsAction(ownerId)
      .then((response) => {
        if (response.status === 200) {
          setShopDetails((response && response.data) || {});
          setOriginalArtists(
            (response && response.data && response.data.artistDetails) || []
          );
          setFilteredArtists(
            (response && response.data && response.data.artistDetails) || []
          );
          setShowLoader(false);
        } else {
          setShowLoader(false);
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
      });
  }

  function getShopDetailsByPublicUrl(urlParam) {
    getShopDetailsByPublicUrlAction(urlParam)
      .then((response) => {
        if (response.status === 200) {
          setShopDetails(response && response.data);
          setOriginalArtists(
            (response && response.data && response.data.artistDetails) || []
          );
          setFilteredArtists(
            (response && response.data && response.data.artistDetails) || []
          );
          setShowLoader(false);
        } else {
          setShowLoader(false);
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
      });
  }

  const getCompanyAddress = () => {
    if (shopData && shopData.shopDetails) {
      if (
        !!shopData.shopDetails.address &&
        !!shopData.shopDetails.city &&
        !!shopData.shopDetails.state &&
        !!shopData.shopDetails.zipcode
      ) {
        return ReactHtmlParser(
          shopData.shopDetails.address +
            ", " +
            shopData.shopDetails.city +
            ", <br>" +
            shopData.shopDetails.state +
            " " +
            shopData.shopDetails.zipcode
        );
      }
    }
    return "";
  };

  const getFilteredArtists = (searchData) => {
    if (searchData && searchData.trim()) {
      let filterResult = originalArtists.filter(
        (artist) =>
          artist.firstname.toLowerCase().includes(searchData.toLowerCase()) ||
          artist.lastname.toLowerCase().includes(searchData.toLowerCase())
      );
      setFilteredArtists(filterResult);
    } else {
      setFilteredArtists(originalArtists);
    }
  };

  const handleClear = () => {
    setSearchParam("");
    setFilteredArtists(originalArtists);
  };

  return (
    <div>
      {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="reg-page">
          <HeaderLogin />
          <div className="loginBg align-items-end flex-column">
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
              <Col>
                <h4 className="title-med mt-0 pt-1">Studio Details</h4>
              </Col>

              <Col className="col-auto close-icon" align="right">
                <Form inline className="justify-content-end">
                  <Row className="trans-listing-head-row">
                    <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                      <div className="multi-permit">
                        <Link
                          to="/studios"
                          className="nav-link p-0 color-black"
                        >
                          <Close
                            style={{
                              stroke: "#fff",
                              height: "40px",
                              width: "40px",
                            }}
                          />
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
            <section className="transaction-list shop-details">
              <div
                className="container-custom"
                style={{ backgroundColor: "#379143", paddingTop: "30px" }}
              >
                <div className="container">
                  <Row>
                    <div className="Col-md-12">
                      <div className="shop-img-banner ">
                        <div className="profile-img profile-img-big">
                          <img
                            src={
                              shopData &&
                              shopData.shopDetails &&
                              shopData.shopDetails.studioLogo
                                ? UrlConstants.AdminCreateTransactionUrl +
                                  "/upload?id=" +
                                  shopData._id +
                                  "&img=" +
                                  shopData.shopDetails.studioLogo
                                : UserImage
                            }
                            alt="user"
                          />
                        </div>
                      </div>
                    </div>
                    <div className=" Col-md-12">
                      <div className="text-UI-wrapper">
                        <h6 className="mb-1">
                          {shopData &&
                            shopData.shopDetails &&
                            shopData.shopDetails.name}
                        </h6>

                        <div className="info-wrapper">
                          <p className="address">{getCompanyAddress()}</p>
                          <div className="contact-number">
                            <strong className="">Phone (Office):</strong>
                            <p>
                              {shopData &&
                              shopData.shopDetails &&
                              shopData.shopDetails.phoneNumber ? (
                                <a
                                  href={
                                    "tele:" + shopData.shopDetails.phoneNumber
                                  }
                                >
                                  <PhoneNumber
                                    phoneNumber={
                                      shopData.shopDetails.phoneNumber
                                    }
                                  />
                                </a>
                              ) : (
                                "-"
                              )}
                            </p>
                          </div>
                          <div className="contact-web">
                            <strong className="">Website:</strong>
                            <p>
                              {shopData &&
                              shopData.shopDetails &&
                              shopData.shopDetails.website
                                ? shopData.shopDetails.website || "-"
                                : "-"}
                            </p>
                          </div>
                        </div>

                        <div className="text-para">
                          {shopData &&
                          shopData.shopDetails &&
                          shopData.shopDetails.aboutCompany ? (
                            <p>{shopData.shopDetails.aboutCompany}</p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </Row>
                  <Row className="mt-5 justify-content-center">
                    <div className="Col-md-12 d-flex justify-content-center">
                      <div
                        className="multi-permit  d-flex align-items-center"
                        style={{ display: "flex", marginRight: "0px" }}
                      >
                        <div className="icon-wrapper">
                          <DebounceInput
                            id="search"
                            minLength={0}
                            debounceTimeout={1500}
                            onChange={(e) => {
                              setSearchParam(e.target.value);
                              getFilteredArtists(e.target.value);
                            }}
                            placeholder="Search by artist name"
                            value={searchParam}
                            autoComplete="off"
                            className="form-control form-control-sm form-control-head"
                          />
                          <span
                            className="form-control-icn"
                            style={{ lineHeight: "25px" }}
                          >
                            <Search />
                          </span>
                        </div>
                        <Button
                          type="button"
                          onClick={handleClear}
                          variant="primary"
                          className="btn-blue btn-head"
                        >
                          Clear
                        </Button>
                      </div>
                    </div>
                  </Row>
                </div>

                <Row>
                  <Col xs="12" sm="12">
                    {filteredArtists && filteredArtists.length > 0 ? (
                      <div className="mb-4">
                        <Carousel className="profile-slider">
                          {filteredArtists
                            .reduce((acc, curr, index) => {
                              const itemsPerSlide =
                                window.innerWidth < 576
                                  ? 1 // Mobile
                                  : window.innerWidth < 768
                                  ? 2 // Tablet
                                  : window.innerWidth < 992
                                  ? 2 // Small Desktops
                                  : 4; // Large Desktops

                              // Group artist details into sets according to screen size
                              if (index % itemsPerSlide === 0) acc.push([]);
                              acc[acc.length - 1].push(curr);
                              return acc;
                            }, [])
                            .map((group, groupIndex) => (
                              <Carousel.Item
                                key={groupIndex}
                                style={{ height: 500 }}
                              >
                                <div className="d-flex justify-content-center flex-wrap">
                                  {group.map((item) => (
                                    <Card
                                      key={item._id}
                                      style={{
                                        width: "18rem",
                                        backgroundColor: "transparent", // Transparent background
                                        border: "none", // Optional: remove border
                                      }}
                                      className="h-100"
                                    >
                                      <div className="proffile-img">
                                        <Card.Img
                                          variant="top"
                                          src={
                                            item.avatar && item.avatar !== "-"
                                              ? UrlConstants.AdminCreateTransactionUrl +
                                                "/upload?id=" +
                                                item._id +
                                                "&img=" +
                                                item.avatar
                                              : UserImage
                                          }
                                          style={{
                                            height: "50%", // Image takes up 100% of its container's height
                                            objectFit: "cover", // Maintain aspect ratio and cover the space
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            let pathObj =
                                              item &&
                                              item.publicUrl &&
                                              item.publicUrl !== undefined
                                                ? {
                                                    pathname:
                                                      "/artists/" +
                                                      (item && item.publicUrl),
                                                  }
                                                : {
                                                    pathname: "/artistDetails",
                                                    state: {
                                                      id: item._id,
                                                      ownerId: shopData._id,
                                                    },
                                                  };
                                            history.push(pathObj);
                                          }}
                                        />
                                      </div>
                                      <Card.Body className="profile-data">
                                        <div
                                          onClick={() => {
                                            let pathObj =
                                              item &&
                                              item.publicUrl &&
                                              item.publicUrl !== undefined
                                                ? {
                                                    pathname:
                                                      "/artists/" +
                                                      (item && item.publicUrl),
                                                  }
                                                : {
                                                    pathname: "/artistDetails",
                                                    state: {
                                                      id: item._id,
                                                      ownerId: shopData._id,
                                                    },
                                                  };
                                            history.push(pathObj);
                                          }}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <Card.Title>
                                            {item.firstname +
                                              " " +
                                              item.lastname}
                                          </Card.Title>
                                          <Card.Subtitle className="mb-2 text-muted">
                                            {item.bio
                                              ? ReactHtmlParser(
                                                  item.bio.length > 235
                                                    ? item.bio.slice(0, 235) +
                                                        "..."
                                                    : item.bio
                                                )
                                              : ""}
                                          </Card.Subtitle>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  ))}
                                </div>
                              </Carousel.Item>
                            ))}
                        </Carousel>
                      </div>
                    ) : (
                      <div
                        className="no-transaction no-record"
                        style={{ backgroundColor: "#379143" }}
                      >
                        <div className="no-transaction-inner">
                          <img src={noRecord} alt="no record" />
                          <p style={{ color: "black" }}>No artists found</p>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </section>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getShopDetailsAction,
    getShopDetailsByPublicUrlAction,
  }
)(ShopDetails);
